export default __webpack_public_path__ + "static/media/synth.40b34a3e.svg";